import React, { Component} from "react";
import { Container ,Row,UncontrolledDropdown ,DropdownToggle,DropdownMenu,DropdownItem,Input,Label} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faAngleDown} from '@fortawesome/free-solid-svg-icons'
import { withRouter } from "react-router-dom";
import {connect } from 'react-redux';

 class AdvancedSearchTransfert extends Component {
        constructor(props) {
          super(props);
          this.onFormSubmit = this.onFormSubmit.bind(this);        
        }
        onFormSubmit(evt) {
          evt.preventDefault()
          this.props.history.push(`/cars/transfert/advanced_search?`);	
        }
     render(){
  
    return (
      <Container>
        <Row className="d-flex justify-content-between mb-3">
          <div className="mb-2 mb-lg-0 col-4 col-md-2 col-lg-1 px-1">
            <UncontrolledDropdown >
              <DropdownToggle
               id="destination"
               className="Advanced-btn-ser pr-2 pl-0  filter-element font-weight-bold "
               >
                <span>Aller</span>
                <img className=""
                        src="/imgs/navebar/downArrow.svg"
                        alt="parcouri"
                        id="arrow-parcourir-big"
                  />
              </DropdownToggle>
             
                <DropdownMenu className="destination-drop-down">
                  <DropdownItem>choix 1</DropdownItem>
                  <DropdownItem>choix 2</DropdownItem>
                </DropdownMenu>
          
            </UncontrolledDropdown>
          </div>

          <div className="mb-2 mb-lg-0 col-8 col-md-5 col-lg-2 px-1">
            <UncontrolledDropdown className="contDrop d-flex justify-content-between align-items-center">
            <input type="text"  name="region" className="filter-element" placeholder=" Aéroport" required/>
            
                <DropdownMenu className="destination-drop-down">
                  <DropdownItem>choix 1</DropdownItem>
                  <DropdownItem>choix 2</DropdownItem>
                </DropdownMenu>
         
            </UncontrolledDropdown>
          </div>
          <div className="mb-2 mb-lg-0 col-12 col-md-5 col-lg-3 px-1">
            <UncontrolledDropdown className=" d-flex justify-content-between align-items-center">
            <input type="text"  name="region" className="filter-element" placeholder=" ALG- Houari Boumediene" required/>
             
                <DropdownMenu className="destination-drop-down">
                  <DropdownItem>choix 1</DropdownItem>
                  <DropdownItem>choix 2</DropdownItem>
                </DropdownMenu>
          
            </UncontrolledDropdown>
          </div>
          <div className="mb-2 mb-lg-0 col-sm-6 col-lg-3 px-1">
            <UncontrolledDropdown className="contDrop">
              <input type="text"  name="region" className="filter-element" placeholder=" Lieu de restitution" required/>

                <DropdownMenu className="destination-drop-down">
                  <DropdownItem>choix 1</DropdownItem>
                  <DropdownItem>choix 2</DropdownItem>
                </DropdownMenu>
            
            </UncontrolledDropdown>
          </div>
          <div className="mb-2 mb-lg-0 col-12 col-sm-6 col-lg-3 px-1">
            <UncontrolledDropdown className="contDrop">
              <DropdownToggle
               id="destination"
               className="Advanced-btn-ser pr-2 pl-0  filter-element font-weight-bold ">
                  Type de véhicule               
                  <img className=""
                        src="/imgs/navebar/downArrow.svg"
                        alt="parcouri"
                        id="arrow-parcourir-big"
                  />
              </DropdownToggle>
          
                <DropdownMenu className="destination-drop-down">
                  <DropdownItem>4x4</DropdownItem>
                  <DropdownItem>Taxi</DropdownItem>
                </DropdownMenu>
         
            </UncontrolledDropdown>
          </div>
        </Row>
        <Row>
          <div className="mb-2  col-12  col-lg-2 d-flex justify-content-between justify-content-sm-start px-1">
            <Label className="incText align-self-center mr-1">
              Nombre de personne
            </Label>
            <Input
               className="Advanced-btn-ser filter-element font-weight-bold mt-1"
              type="number"
              id="increment"
              name="points"
              step="1"
            />
          </div>

          <div className="mb-2 col-12 col-md-6 col-lg-4 px-1">
            <Input
              className="inputs filter-element"
              type="text"
              placeholder="Date"
              onFocus={(e) => {
                e.target.type = "date";
              }}
              style={{
                width: "100%",
                backgroundColor: "white",
                color: "#37296a",
                textAlign: "left",
                fontWeight: "bold",
                fontSize: "15px",
                height: "36px",
              }}
            />
          </div>
          <div className="mb-2 col-md-6 col-lg-3 px-1">
            <Input
              className="inputs filter-element"
              type="text"
              placeholder="Horaire"
              onFocus={(e) => {
                e.target.type = "time";
              }}
              style={{
                width: "100%",
                backgroundColor: "white",
                color: "#37296a",
                textAlign: "left",
                fontWeight: "bold",
                fontSize: "15px",
                height: "36px",
              }}
            />
          </div>
          <div className="mb-3 mb-md-1 col-md-6 col-lg-3 px-1">
            <button
              onClick={this.onFormSubmit.bind(this)}
              className="inputs filter-element"
              style={{
                backgroundColor: "#37296a",
                color: "white",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "15px",
                height: "36px",
                borderRadius: "5px",
                outline: "unset",
                border: "unset"
              }}
            >
              VOIR LES OFFRES
            </button>
          </div>
        </Row>
      </Container>
    );
    }
  }

function mapStateToProps(state) {
  return {}
}
export default withRouter(connect(mapStateToProps)(AdvancedSearchTransfert));